if (!customElements.get('color-swatches')) {
class colorSwatches extends HTMLElement {
  constructor() {
    super();

    this.list = this.querySelector('ul');
    this.url = this.dataset.url;
    this.id = this.dataset.id;
    this.collection = this.dataset.collection
    this.more = this.nextElementSibling;
    this.copmareprice = this.closest('.product-item__info').querySelector('.product_compare_price');
    this.onlyOneVariant = this.closest('.product-item__info').querySelector('.product-item__swatches');
    this.fetchColorSwatches();
  }

  fetchColorSwatches() {
    fetch(this.url)
      .then(response => response.text())
      .then(data => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(data, 'text/html');
        const swatches = htmlDocument.querySelectorAll('li');
        const images = htmlDocument.querySelectorAll('img');
        let activeId = '';

        if (swatches.length) {
          this.list.innerHTML = '';

          const mediaQuery = window.matchMedia('(max-width: 749px)');
          if (mediaQuery.matches) {
            if(this.copmareprice){
              if (swatches.length > 2 && this.more) {
                this.more.classList.remove('hidden');
              }
            }
          }
          if (swatches.length == 1){
            this.onlyOneVariant.classList.add('hidden');
          }
          if (swatches.length > 4 && this.more) {
            this.more.classList.remove('hidden');
          };


          swatches.forEach((swatch, index) => {
            const swatchInput = swatch.querySelector('input');
            const swatchLabel = swatch.querySelector('label');
            const swatchInputId = `group-${this.id}-${this.collection}-${index}`;
            const swatchDataId = `${swatchInput.dataset.id}-${this.collection}`;

            swatchInput.name = this.id
            swatchLabel.setAttribute('for', swatchInputId);
            swatchInput.id = swatchLabel.getAttribute('for');

            if (swatchDataId === this.id) {
              swatchInput.checked = true;
              activeId = swatchInput.dataset.image;
              swatch.classList.add('current-active');
            }

            this.list.appendChild(swatch);

            swatchInput.addEventListener('change', this.handleColorSwatchChange);
          });

          this.moveCurrentSelectedAhead();

          images.forEach(image => {
            this.images.appendChild(image);
            if (activeId === image.dataset.id) {
              image.classList.add('active');
            };
          });
        };
      })
      .catch(error => console.error('Error fetching product swatches:', error));
  }

  // Function to handle color swatch change
  handleColorSwatchChange(event) {
    if(!event.target.getAttribute('data-url')) return;

    const productItem = event.target.closest('.product-item');
    const productMedia = productItem.querySelector('.product-item__media');
    const productItemUrl = event.target.getAttribute('data-url').toString().split("/products")[1];
    const updateProductUrl = productItem.querySelector('.product-item__title a');
    const productImagesUrl = productMedia.querySelectorAll('.product-item__media a.product-item__media-link');
    const productUrl = productItem.querySelector('.product-item__swatches').getAttribute('data-url');
    const splitProductUrl = productUrl.toString().split("/products")[0];
    const finalUrl = splitProductUrl + '/products' +productItemUrl;
    productItem.querySelector('.product-item__plus').setAttribute('href', finalUrl);
    updateProductUrl.setAttribute('href', finalUrl);
    productImagesUrl.forEach(function(productImageUrl){
      productImageUrl.setAttribute('href', finalUrl);
    });


    let imageIndex = 0;

    fetch(finalUrl+'.js')
    .then(response => response.json())
    .then(product => {
      for(const image of product.images){
        const productMediaSwiper = productMedia.querySelectorAll(`.swiper-slide[data-swiper-slide-index="${imageIndex}"]`);
        for(const swiperImage of productMediaSwiper){
          const multiImages = swiperImage.querySelectorAll('.product-item__images img');
          multiImages.forEach(function(multiImage) {
            if(multiImage.classList.contains("mobile-image")) {
              multiImage.setAttribute('src', image + '&width=250');
              multiImage.setAttribute('srcset', image + '&width=250');
            }
            else {
              multiImage.setAttribute('src', image + '&width=400');
              multiImage.setAttribute('srcset', image + '&width=400');
            }
          });
        }
        imageIndex++;
        if(imageIndex > 2) break;
      }
    });
  }

  moveCurrentSelectedAhead() {
    const swatchesAll = document.querySelectorAll(`ul.color-swatches li.current-active`);
    swatchesAll.forEach((swatch) => {
      if(swatch.classList.contains('current-active')){
        const swatchInput = swatch.querySelector('input');
        const activeSwatch = swatch;
        const parentNodeHere = swatch.parentNode;
        parentNodeHere.removeChild(swatch);
        parentNodeHere.insertBefore(activeSwatch, parentNodeHere.childNodes[0]);

        swatchInput.addEventListener('change', this.handleColorSwatchChange);
      }
    });
  }

}

customElements.define('color-swatches', colorSwatches);
}
